import React from 'react'
import { Card, CardActions, CardTitle, CardText } from 'material-ui-legacy/Card'

import { DollarValue, AddedPercentage, PercentageOf } from '../UI/FormulaTokens'
import DeleteButton from '../UI/DeleteButton'
import EditButton from '../UI/EditButton'
import CloseButton from '../UI/CloseButton'

const ReferenceValueCard = props => {
  // Data can be received either as referenceValue or itemData.
  const referenceValue = props.referenceValue || props.itemData

  return (
    <Card>
      <CardTitle title={referenceValue.attributes.name} />

      <CardText>
        <p>
          <strong>Type:</strong> {referenceValue.attributes.formattedType}
        </p>
        <p>
          {referenceValue.attributes.valueType === 'dollar_value' && (
            <DollarValue
              name={referenceValue.attributes.name}
              value={referenceValue.attributes.formattedValue}
            />
          )}
          {referenceValue.attributes.valueType === 'added_percentage' && (
            <AddedPercentage
              name={referenceValue.attributes.name}
              value={referenceValue.attributes.formattedValue}
            />
          )}
          {referenceValue.attributes.valueType === 'percentage_of' && (
            <PercentageOf
              name={referenceValue.attributes.name}
              value={referenceValue.attributes.formattedValue}
            />
          )}
        </p>
      </CardText>

      <CardActions>
        {props.editCallback && <EditButton onTouchTap={props.editCallback} />}
        {props.deleteCallback && (
          <DeleteButton
            onTouchTap={props.deleteCallback}
            confirmMessage={
              <p>
                Are you sure you want to delete{' '}
                <strong>{referenceValue.attributes.name}</strong>? There's no
                undo.
              </p>
            }
          />
        )}
        {props.closeCallback && (
          <CloseButton onTouchTap={props.closeCallback} />
        )}
      </CardActions>
    </Card>
  )
}

export default ReferenceValueCard



// WEBPACK FOOTER //
// ./src/components/ReferenceValues/ReferenceValueCard.jsx